import { Text as TextBase } from 'rebass'

import styled, { css } from 'styled-components'
import { style, height, border, borderRadius, position, right, bottom, left, top, fontStyle } from 'styled-system'

const requiredColor = style({
  prop: 'requiredColor',
  cssProperty: 'color',
  key: 'colors'
})

const Text = styled(TextBase)`
    transition: box-shadow .1s;
    :focus {
        outline: none;
        ${props => `box-shadow: ${props.theme.shadows[2]}`};
    }
  ${height} ${border} ${borderRadius} ${position} ${right}
  ${left}
  ${bottom}
  ${top}
  ${fontStyle}
  ${props =>
    props.required
      ? css`
          :after {
            content: '*';
            ${requiredColor}
          }
        `
      : ''}
`

Text.defaultProps = {
  boxShadow: 2,
  fontSize: 'm',
  requiredColor: 'rgba(235, 81, 96, 0.8)'
}

export default Text
